/* eslint-disable no-unused-vars */
import BaseService from './base.service'
import { ENDPOINT } from '~/api/endpoint'

class UserService extends BaseService {
  constructor(option) {
    super(option)
    return this
  }

  /**
   * @description
   * [Hình ảnh] - Upload hình ảnh người dùng lên server
   * @param {Array} images
  */
  uploadUserImages(image) {
    return this.http.post(ENDPOINT.UPLOAD_USER_IMAGE, image)
    .then(data => data.data)
  }

  /* Danh sách bệnh nhân */
  getUserSeachCondition() {
    return this.http.get(ENDPOINT.USER_CONDITION_SEARCH_STATUS)
      .then(res => res.data.data)
  }

  /* Danh sách bệnh nhân */
  getUserSortCondition() {
    return this.http.get(ENDPOINT.USER_CONDITION_ORDER)
      .then(res => res.data.data)
  }

  /* Danh sách vị thuốc */
  getUsers(params) {
    return this.http.get(ENDPOINT.USERS, { params })
      .then(res => res.data.data)
  }

  /* Chi tiết vị thuốc */
  getUserDetail(userId) {
    return this.http.get(ENDPOINT.USER_DETAIL.replace('{id}', userId))
      .then(res => res.data.data)
  }

  /* Cập nhật vị thuốc */
  updateUser(userId, data) {
    return this.http.put(ENDPOINT.USER_UPDATE.replace('{id}', userId), { data },)
  }

  /* Cập nhật vị thuốc */
  updateUserPasswordAdmin(userId, data) {
    return this.http.post(ENDPOINT.USER_UPDATE_PASSWORD_ADMIN.replace('{id}', userId), { data },)
  }

  /* Tạo vị thuốc mới */
  createUser(data) {
    return this.http.post(ENDPOINT.USER_CREATE, { data })
      .then(res => res.data.data)
  }
}

export default new UserService({ auth: true })
